module.exports = __webpack_public_path__ + "img/samsung-galaxy-a70.e5a5dbe2.png";